"use strict";

(function ($) {
  var defaultOptions = {
    value: 100,
    minValue: 0,
    maxValue: 100,
    text: 'Загрузка...',
    width: '100%',
    hideOnStart: true
  };
  var progressBar = function progressBar(el, options) {
    var self = this;
    var template = '<div class="progress progress-striped active"><div class="progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="100" style="width: 100%;"><span class="sr-only">Загрузка...</span></div></div>';
    self.$el = $(el);
    self.el = el;
    self.options = $.extend({}, defaultOptions, options);
    self.init = function () {
      self.$el.html(template);
      var pb = self.$el.find('.progress-bar');
      pb.attr('aria-valuemin', self.options.minValue);
      pb.attr('aria-valuemax', self.options.maxValue);
      pb.attr('aria-valuenow', self.options.value);
      pb.width(self.options.width);
      var txt = self.$el.find('.sr-only');
      txt.text(self.options.text);
      if (self.options.hideOnStart) {
        self.$el.hide();
      }
    };
    self.show = function () {
      self.$el.show();
    };
    self.hide = function () {
      self.$el.hide();
    };
    self.changeText = function (text) {
      var txt = self.$el.find('.sr-only');
      txt.text(text);
    };
    self.init();
  };

  // check namespace
  $.b2b = $.b2b || {};

  // set wrapper
  $.b2b.progressBar = function (el, options) {
    return new progressBar(el, options);
  };
})(jQuery);